export default {
	retailerRequestRedirectUrl: false,
	termsAndConditionsUrl: "/terms",
	hideRegister: location.host.toLowerCase().indexOf("backoffice") >= 0,
	registerRetailerAction: "new",
	hideForgotPassword: false,
	formIORegistration: true,
	registrationCRM: false,
	hideMSRPMultiplier: false,
	hideCorporateType: true,
	registrationSuccessfulModal: {
		body: `Your new account request has been received.  You will receive an email confirmation shortly.`,
		title: `Registration Successful`,
		size: "md",
		buttons: {
			OK: {
				dismiss: true,
				className: "btn-u-default",
			},
		},
	},
	loginModes: [],
	passwordRules: [],
	hideRegistrationExportPDF: false,
	useOneTimePasscode: true,
	userExistsMessage: "Your email address is already registered as a valid user in our system",
	emailExistsMessage: ($session) => "We see your email address is associated with the following account(s)",
	emailExistsTitle: ($session) => "Email address was found",
	emailNotFoundMessage: "Looks like you're new here.  Let's get you registered!",
	siteAccessMessage: ($session) => `Thank you for requesting to shop at ${$session.clientName}! You should have just received an email with steps	to finalize the registration process for website access.  Please contact us at hello@nextgendallas.com if you need any further assistance.`
};
